import {Endpoint} from '@eryxcoop/appyx-comm';

export default class GetPortfolioAgingTopDebtorsEndpoint extends Endpoint {

    adaptValues({tierCode}) {
        return {
            tier: tierCode,
        }
    }
}
